import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SystemArchitectureSection from "@/components/home/SystemArchitectureSection";
import HeroSection from "@/components/home/HeroSection";
import StormResponseCallout from "@/components/home/StormResponseCallout";
import VideoShowcaseSection from "@/components/home/VideoShowcaseSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import SolutionsSection from "@/components/home/SolutionsSection";
import PricingSummarySection from "@/components/home/PricingSummarySection";
import FinalCTASection from "@/components/home/FinalCTASection";

const Index = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Upfixe Ads",
    "operatingSystem": "Web, Claude MCP, ChatGPT MCP",
    "applicationCategory": "BusinessApplication",
    "description": "Automated 5-ad-group Google Ads campaign generator with live Keyword Planner data, mathematical CPA budget ceilings, and negative keyword filtering directly from a landing page URL.",
    "url": "https://upfixe.com",
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "USD",
      "lowPrice": "99",
      "highPrice": "599",
      "offerCount": "3"
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Upfixe — Google &amp; Bing Ads Campaign Generator | CPA Protector</title>
        <meta name="description" content="Launch a 5-ad-group Google Ads and Microsoft Advertising (Bing Ads) campaign with negative keyword filters in 60s from your landing page URL. Enforce mathematical CPA limits and manage by chat in Claude or ChatGPT." />
        <meta name="keywords" content="automated google ads, bing ads automation, microsoft advertising, google ads from url, 5 ad group campaign, instant google ads generator, chat-native google ads, google ads mcp, PPC agency alternative, target cpa protection" />
        <meta property="og:title" content="Upfixe — Google &amp; Bing Ads Campaign Generator | CPA Protector" />
        <meta property="og:description" content="Directly from your URL: 5 themed ad groups across Google Ads and Microsoft Advertising (Bing Ads), live Keyword Planner data, negative keyword filters, and complete RSA copy ready in 60 seconds." />
        <link rel="canonical" href="https://upfixe.com/" />
        <link rel="alternate" hrefLang="x-default" href="https://upfixe.com/" />
        <link rel="alternate" hrefLang="en" href="https://upfixe.com/" />
        <link rel="alternate" hrefLang="de" href="https://upfixe.com/de" />
        <link rel="alternate" hrefLang="fr" href="https://upfixe.com/fr" />
        <link rel="alternate" hrefLang="en-GB" href="https://upfixe.com/uk" />
        <link rel="alternate" hrefLang="en-AU" href="https://upfixe.com/au" />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>
      <Header />
      <main className="flex-grow">
        <HeroSection />
        <StormResponseCallout />
        <VideoShowcaseSection />
        <SystemArchitectureSection />
        <FeaturesSection />
        <HowItWorksSection />
        <SolutionsSection />
        <PricingSummarySection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
